@use "../../styles/breakpoint.module.scss" as *;

.section {
    composes: gridContainer from "../../styles/composable/layout.module.css";

    > * {
        grid-column: span 6;

        @media ($below-mobile) {
            grid-column: 1 / -1;
        }
    }
}

.eyebrow {
    composes: fontEyebrow from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-8);
}

.title {
    composes: fontHeader34 from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-24);
}
